import React, { useState } from "react";
import { Plural, Trans } from "@lingui/macro";
import { useFYC } from "components/FindYourCruise/useFYC";
import { InstantSearch, Configure } from "react-instantsearch-dom";
import CruiseFilters from "components/FindYourCruise/Components/CruiseFilters";
import * as styles from "./FindYourCruiseSearchBox.module.scss";
import { Button } from "@silversea-ssc/ui-components-react";
import { ApplyButton } from "components/FindYourCruise/Components/ResponsiveFiltersBar";
import { navigate } from "gatsby";
import qs from "qs";
import { useGetTargetPagePath } from "./Utils";
import { useLanguage } from "../../utils/localization/languages/I18nContext";
import { useGeolocation } from "src/utils/localization/geolocation/GeolocationContext";

const FindYourCruiseSearchBox: React.FC = () => {
  const geolocation = useGeolocation();

  const {
    searchClient,
    filterDefaultSearch,
    searchState,
    createURL,
    onSearchStateChange,
    localizedSearchIndexName
  } = useFYC(undefined, geolocation.defaultCurrency, false);

  const [searchParams, setSearchParams] = useState({});
  const language = useLanguage();
  const targetSearchPagePath = useGetTargetPagePath(language);

  const updateSearchStateChange = (updatedSearchState, searchState) => {
    if (updatedSearchState) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { configure, page, ...filteredSearchState } = updatedSearchState;
      onSearchStateChange(updatedSearchState, searchState);
      setSearchParams(filteredSearchState);
    }
  };

  const onSubmit = () => {
    const queryString = qs.stringify(searchParams);
    navigate(`${targetSearchPagePath}?${queryString}`);
    return false;
  };

  return (
    <InstantSearch
      indexName={localizedSearchIndexName}
      searchClient={searchClient}
      searchState={searchState}
      onSearchStateChange={updateSearchStateChange}
      createURL={createURL}
    >
      <Configure
        filters={filterDefaultSearch}
        hitsPerPage={0}
        analytics={process.env.GATSBY_ALGOLIA_ENABLE_ANALYTICS}
        //enablePersonalization={true}
        distinct
      />
      <div
        className={styles.sectionContainer}
        data-content-name="find_your_cruise"
      >
        <div className={styles.container}>
          <div className={styles.title}>
            <Trans>Find your cruise</Trans>
          </div>
          <div className={styles.filters}>
            <CruiseFilters
              openFiltersAppliedFiltersButtonLabel={
                <Trans>Find your cruise</Trans>
              }
              openFiltersButtonLabel={<Trans>Find your cruise</Trans>}
              showFreeTextSearch={false}
              showExpeditionFilter={true}
              specialTypeFilter={undefined}
              showDestinationFilter={true}
              showShipFilter={true}
              showDurationFilter={false}
              showOthersFilter={false}
              showPromosFilter={true}
              modalApplyButton={
                <ApplyButton
                  onClick={onSubmit}
                  label={(_appliedFiltersCount, resultsFoundCount) => (
                    <Plural
                      value={resultsFoundCount || 0}
                      zero="See all   Cruises"
                      one="See all # Cruise"
                      other="See all # Cruises"
                    />
                  )}
                />
              }
            />
          </div>
          <div className={styles.buttonContainer}>
            <Button
              variant="primary"
              renderAs="button"
              onClick={onSubmit}
              data-content-piece="submit_button"
            >
              <Trans>search</Trans>
            </Button>
          </div>
        </div>
      </div>
    </InstantSearch>
  );
};

export default FindYourCruiseSearchBox;
